const styles = ({
  modalProgress: {
    minHeight: '5px',
  },
});

export default styles;
